import { defineComponent as _defineComponent } from 'vue'
import PageHeader from "../ui/PageHeader.vue"

interface LoadingLayoutProps {
  loadingText: string
}


export default /*@__PURE__*/_defineComponent({
  __name: 'LoadingLayout',
  props: {
    loadingText: { default: "" }
  },
  setup(__props: any, { expose: __expose }) {
  __expose();



const __returned__ = { PageHeader }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})